module.exports = fox._r("images/faq-icon-search.png", __webpack_public_path__ + "images/faq-icon-search.png");


//////////////////
// WEBPACK FOOTER
// ./images/faq-icon-search.png
// module id = 12
// module chunks = 2